// A single open bucket -> plain (exact) count.
const EXACT_RANGES = [{ min: 0, max: 2147483647 }];

// Derive a bucket label from its lower bound: < 1000 -> exact count, else K+/M+/B+.
function getRangeLabel(min, isFirstBucket) {
  if (isFirstBucket) {
    return 'EXACT';
  }
  if (min < 1000) {
    return `${min}+`;
  }
  if (min < 1000000) {
    return `${Math.floor(min / 1000)}K+`;
  }
  if (min < 1000000000) {
    return `${Math.floor(min / 1000000)}M+`;
  }
  return `${Math.floor(min / 1000000000)}B+`;
}

function formatCount(count, ranges = []) {
  const n = Number(count) || 0;
  if (!Array.isArray(ranges) || ranges.length === 0) {
    return String(n);
  }

  const matchedIndex = ranges.findIndex(r => n >= r.min && (r.max == null || n <= r.max));

  if (matchedIndex === -1) {
    return String(n);
  }

  const matched = ranges[matchedIndex];

  const label = getRangeLabel(matched.min, matchedIndex === 0);

  return label === 'EXACT' ? String(n) : label;
}

function isCountDisplayEnabled(config = {}, storeKey = 'ajio') {
  const store = storeKey || 'ajio';
  return config.master === true && config.stores?.[store] === true;
}

function getShowFacetCount(config = {}, storeKey = 'ajio') {
  if (!isCountDisplayEnabled(config, storeKey)) {
    return true;
  }
  return config.filterDisplay?.ShowFacetCount === true;
}

function resolveTotalCountDisplay(mode, enabled, ranges) {
  const safeMode = mode || 'none';
  return {
    enabled,
    show: safeMode !== 'none',
    ranges:
      safeMode === 'range' && Array.isArray(ranges) && ranges.length ? ranges : EXACT_RANGES
  };
}

function getPlpTotalCountDisplay(config = {}, storeKey = 'ajio') {
  return resolveTotalCountDisplay(
    config.filterDisplay?.PLPTotalCount,
    isCountDisplayEnabled(config, storeKey),
    config.ranges
  );
}

// ShowFilterTotalCount is a plain boolean toggle: true -> show the total count, false -> hide it.
// No range bucketing here — when shown, getTotalCountLabel renders the plain count.
function getFilterTotalCountDisplay(config = {}, storeKey = 'ajio') {
  return {
    enabled: isCountDisplayEnabled(config, storeKey),
    show: config.filterDisplay?.ShowFilterTotalCount === true
  };
}

function isTotalCountVisible(totalCountDisplay = {}) {
  const { enabled = false, show = false } = totalCountDisplay;
  return !enabled || show;
}

function getTotalCountLabel(count, totalCountDisplay = {}, { suffix = '', legacyText } = {}) {
  const { enabled = false, show = false, ranges = [] } = totalCountDisplay;
  if (!enabled) {
    if (legacyText != null) {
      return legacyText;
    }
    return suffix ? `${count} ${suffix}` : String(count);
  }
  if (!show) {
    return '\u00A0';
  }
  const formatted = formatCount(count, ranges);
  return suffix ? `${formatted} ${suffix}` : formatted;
}

module.exports = {
  formatCount,
  getRangeLabel,
  isCountDisplayEnabled,
  getShowFacetCount,
  resolveTotalCountDisplay,
  getPlpTotalCountDisplay,
  getFilterTotalCountDisplay,
  isTotalCountVisible,
  getTotalCountLabel
};
